import { MutationTree } from 'vuex';
import { Auth, User } from '../types';

const mutations: MutationTree<Auth> = {
  setIsAuth(state: Auth, value: boolean): void {
    state.isAuth = value;
  },

  setUser(state: Auth, value: User): void {
    state.user = value;
  },
};

export default mutations;
